module.exports = __webpack_public_path__ + "img/no-filter-results.90dbcac6.jpg";